import { unref as T, getCurrentScope as j, onScopeDispose as C, ref as v, watch as H } from "vue";
function _(e) {
  return j() ? (C(e), !0) : !1;
}
function A(e) {
  return typeof e == "function" ? e() : T(e);
}
const L = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const k = Object.prototype.toString, B = (e) => k.call(e) === "[object Object]", D = () => {
}, W = L ? window : void 0;
function M(e) {
  var n;
  const s = A(e);
  return (n = s == null ? void 0 : s.$el) != null ? n : s;
}
function S(...e) {
  let n, s, l, a;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([s, l, a] = e, n = W) : [n, s, l, a] = e, !n)
    return D;
  Array.isArray(s) || (s = [s]), Array.isArray(l) || (l = [l]);
  const o = [], f = () => {
    o.forEach((u) => u()), o.length = 0;
  }, g = (u, c, r, i) => (u.addEventListener(c, r, i), () => u.removeEventListener(c, r, i)), p = H(
    () => [M(n), A(a)],
    ([u, c]) => {
      if (f(), !u)
        return;
      const r = B(c) ? { ...c } : c;
      o.push(
        ...s.flatMap((i) => l.map((m) => g(u, i, m, r)))
      );
    },
    { immediate: !0, flush: "post" }
  ), d = () => {
    p(), f();
  };
  return _(d), d;
}
const G = {
  page: (e) => [e.pageX, e.pageY],
  client: (e) => [e.clientX, e.clientY],
  screen: (e) => [e.screenX, e.screenY],
  movement: (e) => e instanceof Touch ? null : [e.movementX, e.movementY]
};
function P(e = {}) {
  const {
    type: n = "page",
    touch: s = !0,
    resetOnTouchEnds: l = !1,
    initialValue: a = { x: 0, y: 0 },
    window: o = W,
    target: f = o,
    scroll: g = !0,
    eventFilter: p
  } = e;
  let d = null, u = 0, c = 0;
  const r = v(a.x), i = v(a.y), m = v(null), h = typeof n == "function" ? n : G[n], w = (t) => {
    const O = h(t);
    d = t, O && ([r.value, i.value] = O, m.value = "mouse"), o && (u = o.scrollX, c = o.scrollY);
  }, y = (t) => {
    if (t.touches.length > 0) {
      const O = h(t.touches[0]);
      O && ([r.value, i.value] = O, m.value = "touch");
    }
  }, b = () => {
    if (!d || !o)
      return;
    const t = h(d);
    d instanceof MouseEvent && t && (r.value = t[0] + o.scrollX - u, i.value = t[1] + o.scrollY - c);
  }, x = () => {
    r.value = a.x, i.value = a.y;
  }, E = p ? (t) => p(() => w(t), {}) : (t) => w(t), X = p ? (t) => p(() => y(t), {}) : (t) => y(t), Y = p ? () => p(() => b(), {}) : () => b();
  if (f) {
    const t = { passive: !0 };
    S(f, ["mousemove", "dragover"], E, t), s && n !== "movement" && (S(f, ["touchstart", "touchmove"], X, t), l && S(f, "touchend", x, t)), g && n === "page" && S(o, "scroll", Y, { passive: !0 });
  }
  return {
    x: r,
    y: i,
    sourceType: m
  };
}
function V(e, n = {}) {
  const {
    handleOutside: s = !0,
    window: l = W
  } = n, a = n.type || "page", { x: o, y: f, sourceType: g } = P(n), p = v(e ?? (l == null ? void 0 : l.document.body)), d = v(0), u = v(0), c = v(0), r = v(0), i = v(0), m = v(0), h = v(!0);
  let w = () => {
  };
  return l && (w = H(
    [p, o, f],
    () => {
      const y = M(p);
      if (!y || !(y instanceof Element))
        return;
      const {
        left: b,
        top: x,
        width: E,
        height: X
      } = y.getBoundingClientRect();
      c.value = b + (a === "page" ? l.pageXOffset : 0), r.value = x + (a === "page" ? l.pageYOffset : 0), i.value = X, m.value = E;
      const Y = o.value - c.value, t = f.value - r.value;
      h.value = E === 0 || X === 0 || Y < 0 || t < 0 || Y > E || t > X, (s || !h.value) && (d.value = Y, u.value = t);
    },
    { immediate: !0 }
  ), S(document, "mouseleave", () => {
    h.value = !0;
  })), {
    x: o,
    y: f,
    sourceType: g,
    elementX: d,
    elementY: u,
    elementPositionX: c,
    elementPositionY: r,
    elementHeight: i,
    elementWidth: m,
    isOutside: h,
    stop: w
  };
}
export {
  V as a,
  M as u
};
//# sourceMappingURL=index-ConQ3o31.js.map
